const base = {
  namespaced: true,
  state: {
    temporarilyItemCode: localStorage.getItem("se_temporarily_item_code") || "",
    msmBalance: undefined, // 短信条数,
    serverStateInfo: JSON.parse(localStorage.getItem("se_server_mix_info") || "{}"),
    instrctionConfigData: [],
    showInstrctionIcon: false,
    instrctionUrl: "",
    instructionInitCodeStack: [],
    showInstructionEntryTips: JSON.parse(localStorage.getItem("se_show_instruction_entry_tips") || "true") // 右下角教程指南
  },
  getters: {},
  mutations: {
    setTemporarilyItemCode(state, data) {
      state.temporarilyItemCode = data;
      localStorage.setItem("se_temporarily_item_code", data);
    },
    msmBalanceCommit(state, data) {
      state.msmBalance = data;
    },
    setServerStateInfo(state, data) {
      state.serverStateInfo = data;
      localStorage.setItem("se_server_mix_info", JSON.stringify(data));
    },
    checkPageHasInstruction(state, data) {
      let path, resourceCode;
      if (data) {
        path = data.path;
        resourceCode = data.resourceCode;
      } else {
        path = "";
        resourceCode = "";
      }
      const currentPath = path || location.pathname;
      let findInstruction;
      if (resourceCode) {
        state.instructionInitCodeStack = resourceCode ? [resourceCode] : [];
        findInstruction = state.instrctionConfigData.find(item => {
          return item.resourceCode === resourceCode;
        });
      } else {
        findInstruction = state.instrctionConfigData.find(item => {
          return item.resourceParam === currentPath;
        });
      }
      if (findInstruction && findInstruction.tutorialUrl) {
        state.showInstrctionIcon = true;
        state.instrctionUrl = findInstruction.tutorialUrl;
      } else {
        state.showInstrctionIcon = false;
      }
    },
    pushInstructionCallback(state, resourceCode) {
      state.instructionInitCodeStack = resourceCode ? [resourceCode] : [];
    },
    setShowInstructionEntryTips(state, data) {
      state.showInstructionEntryTips = data;
      localStorage.setItem("se_show_instruction_entry_tips", data);
    }
  },
  actions: {
    async getvehicleTree({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/queryModelTree", params);
      return data;
    },
    async getAreaList({ rootState }, params = { level: 1 }) {
      const data = await rootState.http("/area/queryAreaCode", params);
      return data;
    },
    async getDictionaryList({ rootState }, dictionaryCode = "") {
      const data = await rootState.http("/basic/queryDictionaryList", {
        dataCode: dictionaryCode
      });
      if (data.data && data.data.list) {
        return data.data.list.map(item => {
          return Object.assign(item, {
            label: item.dataDesc,
            value: item.dataValue
          });
        });
      } else {
        return [];
      }
    },
    async getVehicleInfoByVin({ rootState }, params = {}) {
      const data = await rootState.http("/vehicleModel/getVehicleListByVin", params, { errorMessage: false });
      return data;
    },
    async getSystemValue({ rootState }, name = "") {
      const data = await rootState.http("/basic/getDataValue", {
        dataCode: name
      });
      return data;
    },
    async updateSystemValue({ rootState }, params = {}) {
      const data = await rootState.http("/basic/saveDataValue", params);
      return data;
    },
    async getUploadToken({ rootState }, params = {}) {
      const data = await rootState.http("/filecloud/getOssToken", params);
      return data;
    },
    async getNewOrderMessage({ rootState }, params = {}) {
      const data = await rootState.http("/external/order/message/newOrder", params);
      return data;
    },
    async createTrack({ rootState, commit, dispatch }, pageUrl) {
      const params = {
        pageUrl: pageUrl
      };
      const data = await rootState.http("/logger/trackAccess", params, { errorMessage: false });
      if (rootState.app.appVersion && rootState.app.appVersion !== data.data) {
        await dispatch("user/loginOut", {}, { root: true });
      }
      commit("app/setAppVersion", data.data, { root: true });
      return data;
    },
    async getProtocolVersion({ rootState }, params = {}) {
      const data = await rootState.http("/agreement/findLatestAgreement", params);
      return data;
    },
    async queryStoreMessageBalance({ rootState, commit }, params = {}) {
      const data = await rootState.http("/store/getMessageBalance", params);
      commit("msmBalanceCommit", data.data.smsBalance);
      return data;
    },
    async getSessionExtInfo({ rootState, commit }, params = {}) {
      const {
        data: { fifoStatus, productionBatchNoStatus, purchaseTaxRate, inboundProductTaxMode }
      } = await rootState.http("/order/getOrderMode", params);
      commit("setting/setFifoStatus", fifoStatus, { root: true });
      commit("setting/setInboundProductTaxRateMode", inboundProductTaxMode, { root: true });
      commit("setting/setProductionBatchNoStatus", productionBatchNoStatus, { root: true });

      const data = await rootState.http("/store/refreshSessionExtInfo", params);
      commit("setting/setServiceMode", data.data.orderModelCode, { root: true });
      commit("setting/setInventoryModel", data.data.inventoryModelCode, { root: true });
      commit("setting/setDispatchMode", data.data.assignTaskModeCode, { root: true });
      commit("setting/setServiceModeDesc", data.data.modelDesc, {
        root: true
      });
      commit(
        "common_base/setCurrency",
        {
          separator: data.data.amountThousandSeparator,
          decimalPlaces: data.data.amountDecimalPlace,
          currencySymbol: data.data.currencySymbol || "",
          currencyUnit: data.data.currencyUnit || ""
        },
        { root: true }
      );
      commit("common_base/setCountryStr", data.data.country, { root: true });
      return { ...data.data, fifoStatus, productionBatchNoStatus, purchaseTaxRate, inboundProductTaxMode };
    },
    async queryAllInstructionConfig({ rootState, state, commit }, params = {}) {
      const data = await rootState.http("/tutorial/store/queryTutorials", params);
      state.instrctionConfigData = data?.data?.list || [];
      if (state.instructionInitCodeStack.length > 0) {
        state.instructionInitCodeStack.forEach(code => {
          commit("checkPageHasInstruction", { resourceCode: code });
        });
      } else {
        commit("checkPageHasInstruction");
      }

      return data;
    },
    async jumpPrintPage({ rootState }, params = {}) {
      const data = await rootState.http("/printTemplate/findPrintUrl", params);
      window.open(data.data.printUrl);
      return data;
    }
  }
};

export default base;
